import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';

function label(name) {
  return i18n(`entities.event.fields.${name}`);
}

const fields = {
  id: new IdField('id', label('id')),
  title: new StringField('title', label('title'), {
    "required": true
  }),
  description: new StringField('description', label('description'), {
    "required": true
  }),
  date: new DateTimeField('date', label('date'), {}),
  hour: new StringField('hour', label('hour'), {}),
  duration: new StringField('duration', label('duration'), {}),
  location: new StringField('location', label('location'), {}),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),
  dateRange: new DateTimeRangeField(
    'dateRange',
    label('dateRange'),
  ),
};

export class EventModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
